export default __webpack_public_path__ + "static/media/608.75a812c7.jpg";